<template>
	<div>
		<div class="d-flex slide-slider bg-contentPlayerBg " :class="{
			'width-learning-object':isLearningObjective,
			'width-learning-material':isResources,
			'width-slide-chat':isQuestionAns,
			}">
			<div class="swiper-container gallery-top ">
				<swiper :options="swiperOption" ref="slideSwiper">
					<swiper-slide v-for="(file, index) in slideFiles" v-bind:key="index" :class="index == 0 ? 'lession-first-slide':''">
						<div class="slide-list position-relative">
							<div class="swiper-zoom-container">
								<img :src="file">
								<div class="waterMarkContainer position-absolute d-flex align-items-center justify-content-center flex-column">
									<div class="waterMarkInner">
										<div class="t-headline7 t-color-whiteSelected t-center mgb-16">{{ personalInfo?personalInfo.userId:'' }}</div>
										<div class="t-headline7 t-color-blackHover t-center">{{ personalInfo?personalInfo.userId:'' }}</div>
									</div>
								</div>
							</div>

						</div>

					</swiper-slide>
				</swiper>
				<div class="swiper-button-next swiper-button-white"></div>
				<div class="swiper-button-prev swiper-button-white"></div>

				<!-- <div class="swiper-pagination"   > </div> -->

			</div>
			<div class="d-flex slide-slider-thumbs gallery-thumbs-container flex-column" :class="islightModeActive ? 'bg-documentGray' : 'bg-contentPlayerBg'" id="gallery-thumbs-container">
				<div
						class="pdt-27 pdb-27 pdl-24 pdr-15 sidebarHeader-slide position-relative" :class="islightModeActive ? 'bg-documentGray' : 'bg-contentPlayerBg'">
						<div class="position-abosolute d-flex justify-content-between align-items-center ">
							<div class="t-body6 font-r paging" :class="islightModeActive ? 't-color-headlineHigh' : 't-color-white'">INDEX</div>
							<div class="d-flex align-items-center"><a href="javascript:void(0)"
									class="closebtn pdt-4" :class="islightModeActive ? 't-color-headlineHigh' : 't-color-white'" @click="closeNav()" @keypress="closeNav()" tabindex="0"><i
										class="material-icons w-22 ">close</i></a></div>
						</div>
					</div>
				<swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">

					<swiper-slide v-for="(file, index) in slideFiles" v-bind:key="index">
								<img :src="file">
					</swiper-slide>

				</swiper>
			</div>

		</div>

		<div class="description-sidebar-slide t-color-white  " :class="islightModeActive ? 'bg-documentGray' : 'bg-contentPlayerBg' " v-if="isLearningObjective">
			<div class="pdt-27 pdb-26 pdl-24 pdr-24 sidebarHeader-slide position-relative">
				<div class="position-abosolute d-flex justify-content-between align-items-center ">
					<div class="t-subtitle3 font-m paging" :class="islightModeActive?'t-color-headlineHigh':'t-color-white'">{{  $t('1046') }}</div>
					<div class="d-flex align-items-center"><a href="javascript:void(0)"
							class="closebtn pdt-4" :class="islightModeActive?'t-color-headlineHigh':'t-color-white'" @click="setisLearningObjectiveHandler" @keypress="setisLearningObjectiveHandler" tabindex="0"><i
								class="material-icons w-22 ">close</i></a></div>
				</div>
			</div>
			<div class="pdl-24 pdr-24 t-color-whiteHigh2 font-r t-body1 t-line-h-28">
				<span class="pdb-32">{{ learnPurposes }}</span>
			</div>
		</div>

		<div class="learning-material-sidebar-slide t-color-white  bg-contentPlayerBg" v-if="isResources" >
			<div class="pdt-27 pdb-27 pdl-24 pdr-24 sidebarHeader-slide bg-contentPlayerBg position-relative">
				<div class="position-abosolute d-flex justify-content-between align-items-center ">
					<div class="t-subtitle6 t-color-white font-m paging">{{$t('3186')}}</div>
					<div class="d-flex align-items-center">
						<a @click="setisResourcesHandler" @keypress="setisResourcesHandler" href="javascript:void(0)" tabindex="0"
							class="closebtn t-color-white pdt-4" ><i
								class="material-icons w-22 ">close</i></a></div>
				</div>
			</div>
			<div class="mgt-8 pdl-24 pdr-24" v-if="lesson.learningMaterials && lesson.learningMaterials.length > 0" >

				<div
					class="d-flex align-items-center justify-content-between pdt-4 pdb-4 bg-whiteHover b-whiteBorder b-radius4 mgb-16">
					<div class="d-flex align-items-center flex-grow-1 mgl-24">
						<button
							class="material-icons mdc-icon-button t-color-secondaryBtnText mgl--12">attach_file</button>
						<span class="t-color-whiteHigh t-body1 font-rn pdl-20">{{ lesson.learningMaterials[0].file.originalName }}</span>
					</div>
					<div>
						<button
							class="material-icons mdc-icon-button t-color-iconInactiveText mgr-12" @click="donwloadFile(lesson.learningMaterials[0])" @keypress="donwloadFile(lesson.learningMaterials[0])" tabindex="0">download</button>
					</div>
				</div>


			</div>

		</div>
		<!-- QNA Start here -->

		<question-ans
			v-if="isQuestionAns"
			:learnId="learnId"
			:lessonId="lessonId"
			:isQuestionAns="isQuestionAns"
			:chatType ="'learn'"
			:islightModeActive="islightModeActive"
			@setisQuestionAnsHandler="setisQuestionAnsHandler"
		></question-ans>

	</div>
</template>

<script>
/**
 * 나의 학습 차시 학습창 - 이미지 슬라이드 swiper 컴포넌트(my learning lesson study - slide image swiper component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import learnApi from '@/api/learnApi.js'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import questionAns from '../../questionContent/List.vue'
import localStorageUtil from "@/utils/localStorageUtil";

export default {
	data() {
		return {
			swiperOption: {
				direction:'horizontal',
        slidesPerView: 1,
				spaceBetween: 22,
				observer: true,
				observeParents: true,
				// pagination: {
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				zoom: {
					maxRatio: 1.3,
					minRation: 1,
					toggle: false
				},
			},
			swiperOptionThumbs: {
				slidesPerView: 5,
				spaceBetween: 15,
				centeredSlides: true,
				//touchRatio: 0.2,
				slideToClickedSlide: true,
				allowTouchMove:false,
				direction: 'vertical',
			},
			startIndex: 0,
			startTime: 0,
			// time: 5,
			enablNext: false,
			teacherName : '',
			learnPurposes: '',

		}
	},

	props: ['slideFiles', 'last', 'recent', 'time', 'isAllPages', 'isScroll', 'isTimeline', 'isExpand', 'contentsType','lessonId','learnId','progressionId','setSlideNumber','isLearningObjective','isResources','isQuestionAns','lesson','personalInfo', 'islightModeActive'],

  components: {
		swiper,
		swiperSlide,
		'question-ans': questionAns
	},

	watch:{
		'enablNext' (val){
			this.slideSwiper.allowSlideNext	= val
		},
		'isAllPages' () {
			this.updateSwiper()
		},

		'isScroll' () {
			let direction = this.isScroll ? 'vertical' : 'horizontal'
			this.slideSwiper.changeDirection(direction)
		},

		'isTimeline' () {
			this.updateSwiper()
		},

		'isExpand' () {
			if (this.isExpend) {
				this.swiperOption.slidesPerView = 2
			}else {
				this.swiperOption.slidesPerView = 'auto'
			}
			this.updateSwiper()
		},

		'setSlideNumber' () {
			this.slideSwiper.slideTo(this.setSlideNumber-1)
		}

	},

	mounted() {
		let params = {
				learnId: this.learnId,
				progressionId: this.progressionId
			};

		learnApi.openNextLearning(this.$route.params.learnId)
        	.then(() => {
				learnApi.learnLessonObjective(params).then((response) => {
					let responseData = response.data.data
					this.teacherName = responseData.teacher?responseData.teacher.fullName:''
					this.learnPurposes = this.getLearnPurposes(responseData.learnInfo);
				})
			})
			.catch((err) => {
				console.log("ERROR OPEN NEXT LEARNING API : ", err);
			});	

		this.slideSwiper = this.$refs.slideSwiper.swiper
		this.startIndex = this.recent ? this.recent - 1 : 0
		if (this.startIndex > 0 && this.startIndex < this.slideFiles.length-1 ) {
			this.$confirm({
				title: this.$t('173'), // '학습 중인 강의입니다.',
				content: this.$t('174') + '<br>' + this.$t('175'), //'이전에 학습했던 이력이 있습니다.<br>이어서 학습하시겠습니까?',
				accept: this.$t('177'), //'이어서 보기',
				cancel: this.$t('176'), //'처음부터 보기',
			}).then(() => {
				this.slideSwiper.slideTo(this.startIndex)
			}).catch(() => {
				this.slideSwiper.slideTo(0)
			})
		}else {
			this.slideSwiper.slideTo(0)
		}

		// 첫페이지 진도저장 실행(first load save progress)
		this.$emit('updateProgress')

		if (this.time > 0 && this.startIndex+1 > this.last ) {
			this.runTimer(this.startIndex)
		}else {
			this.enablNext = true
		}

		this.slideSwiper.allowSlideNext	= this.enablNext


		if (this.contentsType != 'PDF') {
			this.slideSwiper.on('slideChange', () => {
				let activeIndex = this.slideSwiper.activeIndex;
			if (this.enablNext === true && (this.slideFiles.length-1) === this.slideSwiper.activeIndex) {
				this.$emit('updateEndedLesson', true)
			}else {
				this.$emit('updateEndedLesson', false)
			}
				this.runTimer(activeIndex)
				this.$emit('updateProgress', activeIndex)
			})
		}

		this.slideSwiper.on('touchStart', () => {
			// if (this.enablNext === true && (this.slideFiles.length-1) === this.slideSwiper.activeIndex+1) {
			// 	this.$emit('updateEndedLesson', true)
			// }else {
			// 	this.$emit('updateEndedLesson', false)
			// }
		})

		this.slideSwiper.on('touchEnd', () => {
			 this.$emit('zoomOut')
		})


		this.slideSwiper.on('imagesReady', () => {
			// console.log('imagesReady!!');
			// this.$showLoading()
			this.$hideLoading()
		 })

		this.$nextTick(() => {
			const swiperThumbs = this.$refs.swiperThumbs.swiper
			this.slideSwiper.controller.control = swiperThumbs
			swiperThumbs.controller.control = this.slideSwiper
		})

		if(typeof(this.$route.query.questionChatType) !='undefined'){
			this.$emit('setisQuestionAns')
			//document.getElementById("video-container").classList.add('chat-active')
		}

	},

	methods: {
		zoomInHandler(){
			this.slideSwiper.zoom.in()
		},
		zoomOutHandler(){
			 this.slideSwiper.zoom.out()
		},

		closeNav() {
			// document.getElementById("gallery-thumbs-container").style.marginRight = "-300px";
			// document.querySelector('.slide-slider').classList.remove("indexed")
			this.$emit('closeImageNav')
		},
		changeSlideIndexChild(currentIndex){
			// alert('call child')

			this.slideSwiper.slideTo(currentIndex)
		},
		// 슬라이드 타이머 실행(Slide timer run)
		runTimer(activeIndex) {
			if (this.last < activeIndex+1) {
				this.enablNext = false
				this.startTime = this.time
				this.setTimer()
			}
		},


		// 슬라이드 타이머 동작(Slide timer action)
		setTimer() {
			this.startTime--
			if(this.startTime > 0) {
				setTimeout(() => {
					this.setTimer()
				}, 1000);
			}else {
				this.enablNext = true
			}
		},

		//swiper UI 업데이트(update swiper UI)
		updateSwiper() {
			this.slideSwiper.update()
		},
		getLearnPurposes(obj) {
      const languageInfo = JSON.parse(localStorageUtil.getLanguageInfo());
      const learnInfo = obj.find(info => info.lang.value === languageInfo.code);
      return learnInfo ? learnInfo.summary : "";
		},
		setisLearningObjectiveHandler(){
			this.$emit('setisLearningObjective')
		},
		setisResourcesHandler(){
			this.$emit('setisResources')
		},
		setisQuestionAnsHandler(){
			// this.closeNav()
			this.$emit('setisQuestionAns')
		},
		// 파일 강제 다운로드(file force download)
		donwloadFile(fileInfo) {
			let fileName = fileInfo.file.id ? fileInfo.file.originalName : fileInfo.split('/').pop()
			let resourceUri = fileInfo.file.id ? fileInfo.file.resourceUri : fileInfo

			httpService.fileDownload(resourceUri).then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]))
				const link = document.createElement('a')

				link.href = url
				link.setAttribute('download', fileName)
				document.body.appendChild(link)
				link.click()
			}).catch(() => {
				console.log('error occured')
			})
		}
	}


}
</script>

<style scoped>
.waterMarkContainer {
   	top:0px;
	width:100% ;
	height: 100%;
	overflow: hidden;
	z-index: 88;
	left: 0;
}
html[dir="rtl"] .waterMarkContainer {
	right: 0;
}
.waterMarkContainer .waterMarkInner div {
	font-size: 4vw;
	line-height: 1;
	opacity: 0.3;
	transform: rotate(-23deg);
	font-weight: 800;
	user-select: none;
	padding-bottom: 5px;
}
</style>
